import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function DeleteAccount() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [txt, setTxt] = useState("");
  const [busy, setBusy] = useState(false);
  if (user?.role === "admin") return null;
  const run = async () => {
    setBusy(true);
    try {
      await api.delete("/me", { data: { confirm: txt } });
      nav("/", { replace: true });
      setTimeout(() => setUser(false), 0);
      toast.success("Your account and data have been deleted.");
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <section className="card-warm mt-8 border border-red-200 p-6" data-testid="delete-account">
      <h2 className="font-display text-2xl font-semibold text-slate-900">Delete my account</h2>
      <p className="mt-1 text-sm text-slate-600">This permanently removes your account and everything in it: testimonies, comments, groups you lead, notes, saved verses, and any child profiles with their progress. This can't be undone.</p>
      <AlertDialog onOpenChange={(o) => !o && setTxt("")}>
        <AlertDialogTrigger asChild>
          <Button data-testid="delete-account-button" variant="outline" className="mt-4 rounded-full border-red-300 text-red-700 hover:bg-red-50"><Trash2 className="mr-1.5 h-4 w-4" />Delete my account</Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete your Cast account?</AlertDialogTitle>
            <AlertDialogDescription>All your data and your children's profiles will be permanently deleted. Type <b>DELETE</b> to confirm.</AlertDialogDescription>
          </AlertDialogHeader>
          <Input data-testid="delete-account-confirm-input" value={txt} onChange={(e) => setTxt(e.target.value)} placeholder="DELETE" autoFocus />
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="delete-account-cancel">Cancel</AlertDialogCancel>
            <Button data-testid="delete-account-confirm" disabled={busy || txt.trim().toUpperCase() !== "DELETE"} onClick={run} className="bg-red-600 text-white hover:bg-red-700">{busy ? "Deleting…" : "Delete forever"}</Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </section>
  );
}
